import { render, staticRenderFns } from "./AstroCalendar.vue?vue&type=template&id=4f264c34&"
import script from "./AstroCalendar.vue?vue&type=script&lang=js&"
export * from "./AstroCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AstroCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f264c34')) {
      api.createRecord('4f264c34', component.options)
    } else {
      api.reload('4f264c34', component.options)
    }
    module.hot.accept("./AstroCalendar.vue?vue&type=template&id=4f264c34&", function () {
      api.rerender('4f264c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/運勢書2025/AstroCalendar.vue"
export default component.exports